import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import api from "@/lib/api";
import { PageHeader, Empty } from "@/components/Bits";
import { money, date } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Download, Printer } from "lucide-react";
import { SuperDelete } from "@/components/SuperDelete";
import { SuperEdit } from "@/components/SuperEdit";

export default function Invoices() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/invoices").then((r) => setRows(r.data)); }, []);

  return (
    <div className="p-4 sm:p-6 lg:p-8">
      <PageHeader title="Customer Invoices" subtitle="Export as CSV / print to PDF to re-key or import into your accounting package" />
      {rows.length === 0 ? <Empty text="No invoices yet. Approve items in Ready to Invoice, then create one." /> : (
        <div className="card-industrial overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-accent/40 text-[11px] font-mono uppercase tracking-wider text-muted-foreground">
              <tr><th className="text-left px-4 py-3">Invoice</th><th className="text-left px-4 py-3">Job</th><th className="text-left px-4 py-3">Customer</th>
              <th className="text-left px-4 py-3">Date</th><th className="text-right px-4 py-3">Net</th><th className="text-right px-4 py-3">VAT</th>
              <th className="text-right px-4 py-3">Total</th><th className="px-4 py-3"></th></tr>
            </thead>
            <tbody className="divide-y divide-border">
              {rows.map((i) => (
                <tr key={i.id} data-testid={`invoice-${i.invoice_number}`}>
                  <td className="px-4 py-3 font-mono-num font-bold">{i.invoice_number}</td>
                  <td className="px-4 py-3"><span className="font-semibold">{i.job_name || i.job_number}</span><div className="font-mono-num text-[10px] text-muted-foreground">{i.job_number}</div></td>
                  <td className="px-4 py-3">{i.customer_name}</td>
                  <td className="px-4 py-3 text-muted-foreground">{date(i.created_at)}</td>
                  <td className="px-4 py-3 text-right font-mono-num">{money(i.subtotal)}</td>
                  <td className="px-4 py-3 text-right font-mono-num text-muted-foreground">{money(i.vat)}</td>
                  <td className="px-4 py-3 text-right font-mono-num font-bold">{money(i.total)}</td>
                  <td className="px-4 py-3 text-right whitespace-nowrap">
                    <a href={`${API}/invoices/${i.id}/export.csv`} data-testid={`invoice-csv-${i.invoice_number}`} className="inline-flex items-center text-muted-foreground hover:text-primary mr-3"><Download className="w-4 h-4" /></a>
                    <a href={`${API}/invoices/${i.id}/print`} target="_blank" rel="noreferrer" data-testid={`invoice-print-${i.invoice_number}`} className="inline-flex items-center text-muted-foreground hover:text-primary"><Printer className="w-4 h-4" /></a>
                    <span className="ml-3 inline-block"><SuperEdit entity="invoice" record={i} label="invoice" onDone={() => window.location.reload()} /></span>
                    <SuperDelete entity="invoice" id={i.id} label={i.invoice_number} onDone={() => setRows(rows.filter((x) => x.id !== i.id))} className="ml-3 h-7" />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
